export default __webpack_public_path__ + "static/media/swap-half-vertical-reverse.7499a24c.svg";